"use client";

import { Page } from "@/app/common/page-component";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import { useRef } from "react";
import { LogoSection } from "./landing-page/company-logo-section";
import { Faq } from "./landing-page/faq-section";
import { FeaturesV2 } from "./landing-page/features-v2";
import { HeroSectionV2 } from "./landing-page/hero-section-v2";
import { ScrollPad } from "./landing-page/scroll-pad";
import { SignUpSection } from "./landing-page/sign-up-section";
import { TestimonialsSection } from "./landing-page/testimonials-section";
import { VisionSection } from "./landing-page/vision-section";

export default function LandingPage() {
    const section1 = useRef<HTMLDivElement>(null);
    const section2 = useRef<HTMLDivElement>(null);
    const section3 = useRef<HTMLDivElement>(null);
    const section4 = useRef<HTMLDivElement>(null);
    const startSection = useRef<HTMLDivElement>(null);

    return (
        <Page withFooter>
            {/* <HeroSection scrollDownAction={navigateDown} /> */}
            <HeroSectionV2
                onScrollDownAction={(v) => {
                    if (v === "blockchain-payouts") {
                        section1.current?.scrollIntoView({ behavior: "smooth" });
                    } else if (v === "split-payments") {
                        section2.current?.scrollIntoView({ behavior: "smooth" });
                    } else if (v === "co-ownership-campaigns") {
                        section3.current?.scrollIntoView({ behavior: "smooth" });
                    } else if (v === "content-marketplace") {
                        section4.current?.scrollIntoView({ behavior: "smooth" });
                    } else if (v === "start-exploring") {
                        startSection.current?.scrollIntoView({ behavior: "smooth" });
                    }
                }}
            />
            <div ref={startSection}>
                <LogoSection />
            </div>
            <TestimonialsSection />
            <LargeHeadingSection />
            <FeaturesV2
                refs={{
                    "blockchain-payouts": section1,
                    "split-payments": section2,
                    "co-ownership-campaigns": section3,
                    "content-marketplace": section4,
                }}
            />
            <ScrollPad />
            <SignUpSection />
            <VisionSection />
            <Faq />
        </Page>
    );
}

function LargeHeadingSection() {
    return (
        <div className="mx-auto my-32 max-w-xl md:my-44">
            <div className="text-balance text-center font-bold text-4xl text-white leading-tight md:text-5xl">
                <span className="text-accent-flashy">No Fees</span> for Vital Features
            </div>
            <div className="mt-8 text-balance text-center text-muted-foreground">
                No exchange rates, zero payment delays, unlimited split payments, automated rights management, and
                stablecoin payments with zero fees.
            </div>
            <div className="mt-8 flex justify-center">
                <Button asChild>
                    <Link href="/onboard">Apply for Onboarding</Link>
                </Button>
            </div>
        </div>
    );
}
